module.exports = "https://cdn-shared.mathletics.com/teacher-modules/course-assign/25/assets/images/e8bd049148b729013447ac3b6ce08aa6.svg";


//////////////////
// WEBPACK FOOTER
// ./~/@3plearning/3p-teacheradmin-assets/assets/UPF/icons/ico_assign.svg
// module id = gOC2
// module chunks = 0